import React, { useState } from "react";
import InputField from "../../component/form/input";
import ThemeButton from "../../component/button/button";
import TextareaField from "../../component/form/textarea";
import SocialMedia from "./socialmedia";
import {
  isFirebaseConfigured,
  saveContactMessageRemote,
} from "../../../services/firebaseRest";

const ContactUs = ({ contact }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitState, setSubmitState] = useState({
    status: "idle",
    message:
      "Firebase is optional right now. Once your keys are added, this form will write directly to Firestore.",
  });

  const handleChange = (e) => {
    setFormData((current) => ({
      ...current,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitState({
      status: "loading",
      message: "Submitting your message...",
    });

    const payload = {
      ...formData,
      source: "portfolio-contact-form",
      submittedAt: new Date().toISOString(),
      status: isFirebaseConfigured() ? "submitted" : "pending-firebase-setup",
    };

    try {
      await saveContactMessageRemote(payload);
      setSubmitState({
        status: "success",
        message: "Message sent to Firebase successfully.",
      });
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      window.localStorage.setItem(
        "ar-portfolio-contact-draft",
        JSON.stringify(payload)
      );
      setSubmitState({
        status: isFirebaseConfigured() ? "error" : "offline",
        message: isFirebaseConfigured()
          ? "Firebase is configured, but the write failed. Check your Firestore rules."
          : "Firebase is not configured yet. The payload was saved locally so you can still test the form UI.",
      });
    }
  };

  return (
    <section
      id="my_contact_list"
      className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8"
    >
      <div className="grid gap-6 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="rounded-[1.75rem] border border-white/15 bg-black/10 p-6">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Contact
          </p>
          <h2 className="font-display text-3xl font-bold text-skin-text md:text-4xl">
            {contact.heading || "Let’s build something useful"}
          </h2>
          <p className="mt-4 text-sm leading-7 text-skin-muted">
            {contact.description ||
              "The form is ready for Firebase-backed submissions, and the social cards remain available as direct contact options."}
          </p>

          <div className="mt-6 space-y-3 text-sm text-skin-text">
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
              <strong className="mr-2 text-skin-accentSoft">Phone:</strong>
              {contact.phone}
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
              <strong className="mr-2 text-skin-accentSoft">Email:</strong>
              {contact.Email}
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
              <strong className="mr-2 text-skin-accentSoft">WhatsApp:</strong>
              {contact.whatsapp}
            </div>
          </div>
        </div>

        <div className="rounded-[1.75rem] border border-white/15 bg-black/10 p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <InputField
              type="text"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <InputField
              type="email"
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <TextareaField
              name="message"
              label="Message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
            />

            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm leading-7 text-skin-muted">
              {submitState.message}
            </div>

            <ThemeButton
              type="submit"
              className="w-full"
              text={submitState.status === "loading" ? "Sending..." : "Submit"}
            />
          </form>
        </div>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {contact.social_media.map((item) => (
          <SocialMedia key={item.title} sm={item} />
        ))}
      </div>
    </section>
  );
};

export default ContactUs;
